import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const NamibiaFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_15621'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_15621)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 9.33333L20 0H0V9.33333Z'
					fill='#0C4799'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M3.3325 4.20002L2.60358 4.99127L2.65906 3.92666L1.57273 3.98103L2.38012 3.26669L1.57273 2.55235L2.65906 2.60672L2.60358 1.54212L3.3325 2.33336L4.06142 1.54212L4.00593 2.60672L5.09227 2.55235L4.28488 3.26669L5.09227 3.98103L4.00593 3.92666L4.06142 4.99127L3.3325 4.20002Z'
					fill='#FFD243'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 14H20V4.66663L0 14Z'
					fill='#1BAC55'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M2.20144 15.8667L21.5502 4.01801L17.798 -1.8667L-1.55078 9.98197L2.20144 15.8667Z'
					fill='white'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M-0.449231 16.1503L22.9731 1.80717L20.4496 -2.15039L-2.97266 12.1928L-0.449231 16.1503Z'
					fill='#E52347'
				/>
			</g>
		</svg>
	);
};

export default NamibiaFlagIcon;
